// extracted by mini-css-extract-plugin
module.exports = {"canvas":"smoke_canvas__oE1ro"};